import { Config, Feature } from '../shared/types/ast';
import { HorseshoeConfig } from '../shared/types/podlet';

const readConfig = () => {
    if (document) {
        const horseshoeConfig = document.getElementById('horseshoe-config');
        if (horseshoeConfig && horseshoeConfig.innerHTML) {
            return JSON.parse(horseshoeConfig.innerHTML) as Config;
        }
    }
    return;
};
let config = readConfig();

export const getConfig = () => {
    if (!config) {
        config = readConfig();
    }
    return config;
};

// Used to get feature flags
export const getFeatureStatus = (
    toggleName: string,
    existingConfig?: HorseshoeConfig,
): boolean => {
    const config = existingConfig || getConfig();
    return (
        config?.features?.find(
            (i) => i.feature.toLowerCase() === toggleName.toLowerCase(),
        )?.enabled || false
    );
};

// Used for abtest features
export const getDetailedFeature = (toggleName: string): Feature | undefined => {
    const config = getConfig();
    return config?.features?.find(
        (i) => i.feature.toLowerCase() === toggleName.toLowerCase(),
    );
};

export const getExperimentVariantFromConfig = (
    experimentName: string,
): string | undefined => {
    const config = getConfig();

    const experiments = config?.experiments;
    if (experiments) {
        let result = undefined;
        Object.keys(experiments).forEach((key) => {
            if (key.includes(experimentName)) {
                result = key.split('_')[1];
            }
        });
        return result;
    } else return undefined;
};
